module.exports = __webpack_public_path__ + "static/media/UserManualSystemAdmin.f827dd25.pdf";